import { BrandKicker, PulseTrace } from '../../components/brand';
import styled from 'styled-components';
import React from 'react';

// import { sendPageView } from '../../utils/analytics'
import { useTranslation } from 'react-i18next';
import Signature from '../../components/ui/elements/Signature';
import { PortfolioItemOverview } from './PortfolioItemOverview';
import Seo from '../../components/seo/Seo';

export const Layout = styled.div`
  min-height: 100vh;
  color: var(--ink);
  background: var(--paper);
  padding: 160px 0 80px;
  @media (max-width: 768px) {
    padding-top: 130px;
  }
`;

const Hero = styled.section`
  max-width: var(--page-width);
  margin: 0 auto;
  padding: 0 var(--gutter) 4rem;
`;

const HeroKicker = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.28rem;
  font-size: 1.4rem;
  color: var(--muted);
  margin-bottom: 1.5rem;
`;

const HeroTitle = styled.h1`
  font-size: clamp(4.4rem, 7.4vw, 10.6rem);
  line-height: 1.05;
  font-weight: 600;
  margin: 0;
  color: var(--ink);
`;

const HeroSub = styled.p`
  margin-top: 1.8rem;
  max-width: 760px;
  font-size: 1.6rem;
  line-height: 1.7;
  color: var(--ink);
`;

const SignatureAccent = styled(Signature)`
  display: inline-block;
  font-size: 1.3em;
  font-weight: 400;
  font-style: normal;
  font-synthesis: none;
  letter-spacing: 0;
  padding-right: 0.1em;
  color: var(--ink);
  vertical-align: baseline;
  margin-left: 0.03em;
  @media (max-width: 768px) {
    font-size: 1.25em;
    vertical-align: baseline;
  }
`;

const ProjectsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8rem;
  counter-reset: projects;
  width: 100%;
  max-width: var(--page-width);
  margin: 0 auto;
  padding: 0 var(--gutter);
  @media (max-width: 768px) {
    gap: 3rem;
  }
`;

const OurWork = React.memo(() => {
  const { t, i18n } = useTranslation('ourWork');
  const lang = i18n.language?.startsWith('fr') ? 'fr' : 'en';
  const canonicalPath = lang === 'fr' ? '/fr/nos-realisations' : '/en/our-work';
  const homePath = lang === 'fr' ? '/fr' : '/';

  const projectsTranslations = t('projects', { returnObjects: true });
  //take "projectsTranslations" and map it to a projects array
  const projects = Object.keys(projectsTranslations).map((key) => ({
    ...projectsTranslations[key],
  }));

  // useEffect(() => {
  //   sendPageView()
  // }, [])

  return (
    <Layout>
      <Seo
        title="Our Work | SOR SEO Case Studies & Portfolio"
        description="Explore custom software, web apps, and SEO projects delivered by SOR SEO across automotive, healthcare, legal tech, construction, and hospitality."
        canonicalPath={canonicalPath}
      />
      <Hero>
        <BrandKicker>{t('projectsOverview.kicker')}</BrandKicker>
        <HeroTitle>
          {lang === 'fr' ? 'Des idées fortes' : 'Bold thinking'}
          <br />
          <SignatureAccent>
            {lang === 'fr' ? 'Du concret' : 'Made real'}
          </SignatureAccent>
        </HeroTitle>
        <HeroSub>{t('projectsOverview.subheading')}</HeroSub>
        <PulseTrace />
      </Hero>

      <ProjectsList>
        {projects.map((item) => (
          <PortfolioItemOverview data={item} key={item.slug || item.title} />
        ))}
      </ProjectsList>
    </Layout>
  );
});

export default OurWork;
